/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon16Solid = forwardRef('ArrowCLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.89 13.378a1.25 1.25 0 0 1-1.768.012L5.28 9.597a2.25 2.25 0 0 1-.01-3.193l3.788-3.788a1.25 1.25 0 1 1 1.767 1.768l-3.61 3.61 3.663 3.616a1.25 1.25 0 0 1 .012 1.768Z" })));
});
